import React from "react";
import { Stack } from "@chakra-ui/core";
import { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { i18n } from "next-i18next";

import Navbar from "~/sections/Navbar";
import Footer from "~/sections/Footer";
import PlansHero from "~/sections/Plans/PlansHero";
import PlansFeatures from "~/sections/Plans/PlansFeatures";
import PlansPrices from "~/sections/Plans/PlansPrices";
import FAQs from "~/sections/Plans/FAQs";
import StickyButtons from "~/sections/StickyButtons";
import { useTranslation } from "~/i18n/hooks";
import CreateAccountCTA from "~/components/CreateAccountCTA";

const PlansRoute: React.FC = () => {
  const t = useTranslation();

  return (
    <Stack height="100%" minHeight="100vh" spacing={0}>
      <Head>
        <title>{t("plans.title")}</title>
        <meta content={t("plans.description")} name="description" />
        <meta content={t("home.keywords")} name="keywords" />
        <link
          href={`${process.env.URL}/planes`}
          hrefLang="x-default"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/planes`}
          hrefLang="es"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/pt/planos`}
          hrefLang="pt"
          rel="alternate"
        />
        <link
          href={`${process.env.URL}/en/plans`}
          hrefLang="en"
          rel="alternate"
        />
        <meta content={t("home.title")} property="og:title" />
        <meta content={t("home.description")} property="og:description" />
        <meta
          content={`${process.env.URL}/og-image-${i18n.language}.jpg`}
          property="og:image:url"
        />
        <meta content={t("home.title")} name="twitter:title" />
        <meta content={t("home.description")} name="twitter:description" />
        <meta
          content={`${process.env.URL}/og-image-${i18n.language}.jpg`}
          property="twitter:image"
        />
        <meta
          name="facebook-domain-verification"
          content="zkpe1pbv54w2vb37xfieodiezyc606"
        />
      </Head>
      <Navbar backgroundColor="green.400" color="white" />
      <PlansHero />
      <PlansPrices />
      <PlansFeatures />
      <CreateAccountCTA
        title={"createAccount.titlePlans"}
        subtitle={"createAccount.subtitlePlans"}
        btnText={"createAccount.actionPlans"}
        svg1={"/assets/create-account-cta-0.svg"}
        svg2={"/assets/create-account-cta-1.svg"}
      />
      <FAQs />
      <Footer />
      <StickyButtons />
    </Stack>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  // Return stores so we can build a directory
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
};

export default PlansRoute;
